import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import Loading from "./Loading";
import { useCore } from "store/core";
import { axiosInstance } from "store/auth";

export default function ReportPreviewModal(props) {
  const core = useCore();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [watchData, setWatchData] = useState(null);
  const [watchOrderData, setWatchOrderData] = useState(null);
  const [watchLoading, setWatchLoading] = useState(false);
  const [watchError, setWatchError] = useState(false);
  const [watchOrderError, setWatchOrderError] = useState(false);

  useEffect(() => {
    setWatchData(null);
    setWatchOrderData(null);
    setLoading(true);
    setData(null);
    if (!props.id) return;

    core.dispatch(
      core.getProductViewCount(props.id, (res) => {
        setData(res);
        setLoading(false);
      })
    );

    fetchWatchReport(props.id);
  }, [props.id]);

  const fetchWatchReport = async (movieId) => {
    setWatchLoading(true);
    setWatchError(false);
    setWatchOrderError(false);
    try {
      const response = await axiosInstance.get(`/panel/watch-rep/${movieId}`);
      setWatchData(response.data);
    } catch (error) {
      console.error("Error fetching watch report:", error);
      setWatchError(true);
    }

    try {
      const orderResponse = await axiosInstance.get(
        `/panel/orders/product/${movieId}`
      );

      setWatchOrderData(orderResponse.data);
    } catch (error) {
      console.error("Error fetching watch report:", error);
      setWatchOrderError(true);
    }

    setWatchLoading(false);
  };

  return (
    <Modal
      show={props.show}
      size={"modal-md"}
      title={props.title}
      handleClose={props.close}
    >
      {loading && <Loading />}

      {data && (
        <div className="p-5">
          <span>نمایش با اشتراک :</span>
          <span>{data.subscription_u}</span>
          <hr />
          <span>(همراه اول) نمایش با اشتراک :</span>
          <span>{data.mci_subscription_u}</span>
          <hr />
          <span>نمایش با بلیت :</span>
          <span>{data.ticket_u}</span>
          <hr />
          <span>نمایش با خرید فیلم :</span>
          <span>{data.buyMovie_u}</span>
          <hr />
          <span>نمایش رایگان :</span>
          <span>{data.free_u}</span>
          <hr />
          <span>کل نمایش :</span>
          <span>{data.total_u}</span>
          <hr />
        </div>
      )}

      {/* نمایش اطلاعات فیلم */}
      {watchLoading && (
        <div className="flex justify-center py-4">
          <Loading />
        </div>
      )}

      {watchError && (
        <div className="text-center text-red-500 py-4">
          مشکلی در دریافت اطلاعات پیش آمد!
        </div>
      )}

      {watchData && !watchError && (
        <div className="p-5 mt-4 border-t">
          <h4 className="text-lg font-semibold">{watchData.movie_title}</h4>
          <p>تعداد تماشا: {watchData.unique_viewers}</p>
          <p>زمان کل مشاهده (ثانیه): {watchData.total_watch_time_seconds}</p>
          <p>زمان کل مشاهده (دقیقه): {watchData.total_watch_time_minutes}</p>
          <p>
            مدت زمان کل (ساعت:دقیقه): {watchData.total_watch_time_formatted}
          </p>
        </div>
      )}

      {watchOrderError && (
        <div className="text-center text-red-500 py-4">بدون فروش</div>
      )}

      {watchOrderData && (
        <div className="p-5 mt-4 border-t">
          <h4 className="text-lg font-semibold">اطلاعات فروش</h4>
          <p>تعداد کل سفارشات: {watchOrderData.successful_orders_count}</p>
          <p>
            تعداد سفارشات دلاری: {watchOrderData.successful_orders_count_USD}
          </p>
          <p>
            تعداد سفارشات ریالی: {watchOrderData.successful_orders_count_IRR}
          </p>
          <p>
            مجموع فروش دلاری: {watchOrderData.successful_total_amount_USD} دلار
          </p>
          <p>
            مجموع فروش ریالی: {watchOrderData.successful_total_amount_IRR} ریال
          </p>
        </div>
      )}
    </Modal>
  );
}
